/* eslint-disable no-undef */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      loading: "Loading…",
      message_check_profile:
        "Incorrect User Information, Please contact Service Desk",
      greet: "Hello",
      logout_text: "Logout",
      text_notfound: "Data not found",
      more: "More",
      veiw_text: "Payroll cutoff Calendar",
      periodOff:
        "Advanced salary request will open to submit during 2nd- 5th of each month.",
      view: "view",
      notification: "Notification",
      notificationSuccess: "Your request has been submitted",
      notificationFail: "You have enter an invalid amount. Please try again",
      confirmCancel: "Do you want to cancel the request?",
      readmore: "Read more",
      message_data: "No Data",
      btn_confirm: "Yes",
      btn_cancel: "No",
      btn_ok: "Ok",
      btn_CloseWindow: "Close",
      CalendarPupup: "Calendar Payroll Cutoff",
      profile: {
        phone: "Phone",
        joined: "Joined",
        service_year: "Service Year",
      },
      adv_salary_request: {
        unit: "Baht",
        title: "Advance Salary Request",
        title_detail: "Request Details",
        massage: "Not over 50% of your Salary and Minimum 500",
        btn_send_request: "Send Request",
        btn_cancel: "Cancel",
        request: "Request",
        approved: "Approved",
        requested: "Requested",
        request_detail: "Request Amount",
        requested_detail: "Requested Amount",
        approved_detail: "Approved Amount",
        remark: "Remark",
      },
      timeanddate: {
        time_in_out: "Time In/Out",
        time_late_this_week: "Late",
        time_vacation_leave: "Vacation Leave Balance",
        time_sick_days: "Sick Leave",
      },
      time_list_box: {
        timeanddate_in_out: {
          title: "Time In Out",
          date: "Date",
          timein: "Time In",
          timeout: "Time Out",
          time_absence: "Absence",
          overtime: "OT",
          total: "Total",
          unit: "Hrs.",
        },
        timeanddate_late_this_week: {
          title: "Late Time",
          date: "Date",
          overtime: "Late Time",
          total: "Total",
          unit: "Hrs.",
        },
        timeanddate_vacation_leave: {
          title: "Vacation Leave",
          date: "Date",
          hour: "Hrs.",
          remark: "Remark",
          total: "Total",
          unit: "Days",
        },
        timeanddate_sick: {
          title: "Sick Leave",
          date: "Date",
          hour: "Hrs.",
          remark: "Remark",
          total: "Total",
          unit: "Hrs.",
        },
      },
      service_menu: {
        payroll_calendar: "Payroll Calendar",
        ppt_consent: "Privacy notice and consent",
        uniform_survey: "Uniform Survey",
        pttt: "Employee Purchase Program",
        srs: "Security Request",
        locker: "Locker Management",
      },
      accept: "Accept",
      decline: "Decline",
      cancel: "Cancel",
      submit: "Submit",
      consent: {
        user_agreement: {
          modal_title: "Data Privacy Consent Statement",
          first_tab_btn_label: "I have read and understood",
        },
      },
    },
  },
  th: {
    translation: {
      loading: "กำลังประมวลผล…",
      message_check_profile: "ข้อมูลผู้ใช้ไม่ถูกต้อง กรุณาติดต่อ Service Desk",
      greet: "สวัสดี",
      logout_text: "ออกจากระบบ",
      text_notfound: "ไม่พบข้อมูล",
      more: "อ่านต่อ",
      veiw_text: "ปฏิทินการเบิกเงินกลางเดือน",
      view: "แสดง",
      notification: "แจ้งเตือน",
      notificationSuccess: "เราได้รับข้อมูลของท่านเรียบร้อยแล้ว",
      notificationFail: "คุณระบุยอดเงินไม่ถูกต้อง กรุณาระบุยอดเงินใหม่อีกครั้ง",
      confirmCancel: "คุณต้องการยกเลิกการขอ หรือไม่?",
      periodOff: "เบิกเงินกลางเดือนจะเปิดตั้งแต่วันที่ 2-5 ของทุก ๆ เดือน",
      readmore: "อ่านต่อ",
      message_data: "ไม่พบข้อมูล",
      btn_confirm: "ใช่",
      btn_cancel: "ไม่ใช่",
      btn_ok: "ตกลง",
      btn_CloseWindow: "ปิด",
      CalendarPupup: "ปฏิทินการจ่ายเงินเดือน",
      profile: {
        phone: "เบอร์โทร",
        joined: "วันเร่ิมงาน",
        service_year: "อายุงาน",
      },
      adv_salary_request: {
        unit: "บาท",
        title: "ขอเบิกเงินกลางเดือน",
        title_detail: "รายละเอียดการขอเบิกเงินล่าสุด",
        massage: "สามารถเบิกได้ไม่เกิน 50% ของเงินเดือนและขั้นต่ำ 500 บาท",
        btn_send_request: "ส่งคำร้องขอ",
        btn_cancel: "ยกเลิกคำร้องขอ",
        request: "ขอเบิกเงิน",
        approved: "เบิกได้จริง",
        requested: "จำนวนที่ร้องขอ",
        request_detail: "จำนวนเงินที่ต้องการเบิกล่วงหน้า",
        requested_detail: "จำนวนเงินที่ร้องขอเบิก",
        approved_detail: "จำนวนเงินที่ได้รับอนุมัติแล้ว",
        remark: "หมายเหตุ",
      },
      timeanddate: {
        time_in_out: "เวลา เข้า/ออก",
        time_late_this_week: "เวลาที่สาย",
        time_vacation_leave: "ลาพักร้อนคงเหลือ",
        time_sick_days: "ลาป่วย",
      },
      time_list_box: {
        timeanddate_in_out: {
          title: "เวลา เข้า/ออก",
          date: "วันที่",
          timein: "เวลาเข้า",
          timeout: "เวลาออก",
          time_absence: "ขาดงาน",
          overtime: "ล่วงเวลา",
          total: "รวม",
          unit: "ชม.",
        },
        timeanddate_late_this_week: {
          title: "สาย",
          date: "วันที่",
          overtime: "จำนวนชั่วโมง",
          total: "รวม",
          unit: "ชม.",
        },
        timeanddate_vacation_leave: {
          title: "ประวัติลาพักร้อน",
          date: "วันที่",
          hour: "ชม.",
          remark: "เหตุผล",
          total: "รวม",
          unit: "วัน",
        },
        timeanddate_sick: {
          title: "ลาป่วย",
          hour: "ชั่วโมง",
          date: "วันที่",
          remark: "เหตุผล",
          total: "รวม",
          unit: "ชม.",
        },
      },
      service_menu: {
        payroll_calendar: "ปฏิทินเบิกเงิน",
        ppt_consent: "นโยบายความเป็นส่วนตัวและการให้ความยินยอม",
        uniform_survey: "แบบสำรวจเครื่องแบบ",
        pttt: "สินค้าสำหรับกลุ่มลูกค้าพนักงาน",
        srs: "บริการด้านการรักษาความปลอดภัย",
        locker: "จัดการล็อกเกอร์ของฉัน",
      },
      accept: "ยอมรับ",
      decline: "ไม่ยินยอม",
      cancel: "ยกเลิก",
      submit: "ส่ง",
      consent: {
        user_agreement: {
          modal_title: "Data Privacy Consent Statement",
          first_tab_btn_label:
            "ข้าพเจ้าได้อ่านและเข้าใจข้อความที่ระบุไว้ข้างต้นโดยตลอดแล้ว",
        },
      },
    },
  },
};

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("Language")
      ? localStorage.getItem("Language")
      : "th", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
